export const data = [
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 1,
    membership_count: 59604,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 2,
    membership_count: 51186,
    median_wc_lbs: -2.599971771
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 3,
    membership_count: 46865,
    median_wc_lbs: -3.600006104
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 4,
    membership_count: 43562,
    median_wc_lbs: -4.629704142
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 5,
    membership_count: 39701,
    median_wc_lbs: -5.511556555
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 6,
    membership_count: 35745,
    median_wc_lbs: -6.399993896
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 7,
    membership_count: 32117,
    median_wc_lbs: -7.054794072
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 8,
    membership_count: 28465,
    median_wc_lbs: -7.800003052
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 9,
    membership_count: 25114,
    median_wc_lbs: -8.400001526
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 10,
    membership_count: 21626,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 11,
    membership_count: 18568,
    median_wc_lbs: -9.479875592
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 12,
    membership_count: 15886,
    median_wc_lbs: -9.920801798
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 13,
    membership_count: 13514,
    median_wc_lbs: -10.19999695
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 14,
    membership_count: 11347,
    median_wc_lbs: -10.5821869
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 15,
    membership_count: 9713,
    median_wc_lbs: -10.6000061
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 16,
    membership_count: 8185,
    median_wc_lbs: -10.8999939
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 17,
    membership_count: 6969,
    median_wc_lbs: -11
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 18,
    membership_count: 6000,
    median_wc_lbs: -11.02311311
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 19,
    membership_count: 5124,
    median_wc_lbs: -11
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 20,
    membership_count: 4476,
    median_wc_lbs: -11.02311311
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 21,
    membership_count: 3792,
    median_wc_lbs: -11
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 22,
    membership_count: 3251,
    median_wc_lbs: -11
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 23,
    membership_count: 2848,
    median_wc_lbs: -11
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 24,
    membership_count: 2434,
    median_wc_lbs: -10.58219531
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 25,
    membership_count: 2105,
    median_wc_lbs: -10.3999939
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 26,
    membership_count: 1842,
    median_wc_lbs: -10.5821869
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 27,
    membership_count: 1590,
    median_wc_lbs: -9.850006104
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 28,
    membership_count: 1393,
    median_wc_lbs: -9.999988556
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 29,
    membership_count: 1230,
    median_wc_lbs: -9.489942001
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 30,
    membership_count: 1098,
    median_wc_lbs: -9.650174502
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 31,
    membership_count: 1002,
    median_wc_lbs: -9.038953591
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 32,
    membership_count: 891,
    median_wc_lbs: -9.7003429
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 33,
    membership_count: 789,
    median_wc_lbs: -9.100006104
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 34,
    membership_count: 711,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 35,
    membership_count: 621,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 36,
    membership_count: 541,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 37,
    membership_count: 492,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 38,
    membership_count: 449,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 39,
    membership_count: 402,
    median_wc_lbs: -9.439938559
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 40,
    membership_count: 372,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 41,
    membership_count: 323,
    median_wc_lbs: -8.818490487
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 42,
    membership_count: 299,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 43,
    membership_count: 272,
    median_wc_lbs: -8.600002289
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 44,
    membership_count: 228,
    median_wc_lbs: -8.156698723
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 45,
    membership_count: 230,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 46,
    membership_count: 188,
    median_wc_lbs: -9.019478898
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 47,
    membership_count: 181,
    median_wc_lbs: -8.598031589
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 48,
    membership_count: 150,
    median_wc_lbs: -8.499016558
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 49,
    membership_count: 141,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 50,
    membership_count: 127,
    median_wc_lbs: -9.399993896
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 51,
    membership_count: 108,
    median_wc_lbs: -9.400001526
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 52,
    membership_count: 98,
    median_wc_lbs: -8.598027384
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 53,
    membership_count: 74,
    median_wc_lbs: -7.450004578
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 54,
    membership_count: 77,
    median_wc_lbs: -8
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 55,
    membership_count: 58,
    median_wc_lbs: -8.046875934
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 56,
    membership_count: 50,
    median_wc_lbs: -7.747860139
  },
  {
    bmi_bin: "healthy",
    sex: "F",
    tenure_week: 57,
    membership_count: 50,
    median_wc_lbs: -8.599998474
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 1,
    membership_count: 2608,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 2,
    membership_count: 2165,
    median_wc_lbs: -3.086475035
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 3,
    membership_count: 1999,
    median_wc_lbs: -4.629704142
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 4,
    membership_count: 1831,
    median_wc_lbs: -6.100006104
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 5,
    membership_count: 1602,
    median_wc_lbs: -7.054785662
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 6,
    membership_count: 1392,
    median_wc_lbs: -8.157096973
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 7,
    membership_count: 1174,
    median_wc_lbs: -8.902262178
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 8,
    membership_count: 983,
    median_wc_lbs: -9.479884002
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 9,
    membership_count: 812,
    median_wc_lbs: -10
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 10,
    membership_count: 678,
    median_wc_lbs: -10.49108619
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 11,
    membership_count: 554,
    median_wc_lbs: -10.6000061
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 12,
    membership_count: 451,
    median_wc_lbs: -10.58219531
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 13,
    membership_count: 374,
    median_wc_lbs: -10.5821827
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 14,
    membership_count: 306,
    median_wc_lbs: -11
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 15,
    membership_count: 249,
    median_wc_lbs: -10.8999939
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 16,
    membership_count: 212,
    median_wc_lbs: -9.650166092
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 17,
    membership_count: 178,
    median_wc_lbs: -9.369646143
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 18,
    membership_count: 162,
    median_wc_lbs: -10.09999847
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 19,
    membership_count: 133,
    median_wc_lbs: -10
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 20,
    membership_count: 113,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 21,
    membership_count: 105,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 22,
    membership_count: 89,
    median_wc_lbs: -8.399993896
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 23,
    membership_count: 81,
    median_wc_lbs: -6.613867866
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 24,
    membership_count: 66,
    median_wc_lbs: -7.300003052
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 25,
    membership_count: 53,
    median_wc_lbs: -7.716179176
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 26,
    membership_count: 43,
    median_wc_lbs: -5.952474351
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 27,
    membership_count: 46,
    median_wc_lbs: -6.727389779
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 28,
    membership_count: 40,
    median_wc_lbs: -6.944556213
  },
  {
    bmi_bin: "healthy",
    sex: "M",
    tenure_week: 29,
    membership_count: 31,
    median_wc_lbs: -3.527392831
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 1,
    membership_count: 73430,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 2,
    membership_count: 70204,
    median_wc_lbs: -3.199996948
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 3,
    membership_count: 67616,
    median_wc_lbs: -4.699996948
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 4,
    membership_count: 65767,
    median_wc_lbs: -6
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 5,
    membership_count: 62647,
    median_wc_lbs: -7.200012207
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 6,
    membership_count: 59606,
    median_wc_lbs: -8.400009155
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 7,
    membership_count: 56389,
    median_wc_lbs: -9.5
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 8,
    membership_count: 52840,
    median_wc_lbs: -10.58219531
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 9,
    membership_count: 49149,
    median_wc_lbs: -11.59999084
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 10,
    membership_count: 45172,
    median_wc_lbs: -12.56634222
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 11,
    membership_count: 41339,
    median_wc_lbs: -13.3999939
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 12,
    membership_count: 37385,
    median_wc_lbs: -14.30000305
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 13,
    membership_count: 33793,
    median_wc_lbs: -15
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 14,
    membership_count: 30213,
    median_wc_lbs: -15.87328456
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 15,
    membership_count: 27179,
    median_wc_lbs: -16.53466966
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 16,
    membership_count: 24403,
    median_wc_lbs: -17.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 17,
    membership_count: 21819,
    median_wc_lbs: -18
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 18,
    membership_count: 19245,
    median_wc_lbs: -18.59999084
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 19,
    membership_count: 17021,
    median_wc_lbs: -19.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 20,
    membership_count: 15191,
    median_wc_lbs: -19.8416036
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 21,
    membership_count: 13491,
    median_wc_lbs: -20.30000305
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 22,
    membership_count: 11895,
    median_wc_lbs: -20.80000305
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 23,
    membership_count: 10497,
    median_wc_lbs: -21.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 24,
    membership_count: 9260,
    median_wc_lbs: -21.82576732
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 25,
    membership_count: 8006,
    median_wc_lbs: -22.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 26,
    membership_count: 7039,
    median_wc_lbs: -22.69999695
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 27,
    membership_count: 6224,
    median_wc_lbs: -23
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 28,
    membership_count: 5410,
    median_wc_lbs: -23.3999939
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 29,
    membership_count: 4769,
    median_wc_lbs: -23.80993104
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 30,
    membership_count: 4262,
    median_wc_lbs: -24
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 31,
    membership_count: 3774,
    median_wc_lbs: -24.25084884
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 32,
    membership_count: 3362,
    median_wc_lbs: -24.25084884
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 33,
    membership_count: 3006,
    median_wc_lbs: -24.5
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 34,
    membership_count: 2616,
    median_wc_lbs: -24.3999939
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 35,
    membership_count: 2370,
    median_wc_lbs: -24.69177084
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 36,
    membership_count: 2063,
    median_wc_lbs: -24.99999809
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 37,
    membership_count: 1867,
    median_wc_lbs: -25
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 38,
    membership_count: 1661,
    median_wc_lbs: -25
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 39,
    membership_count: 1458,
    median_wc_lbs: -25
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 40,
    membership_count: 1316,
    median_wc_lbs: -25.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 41,
    membership_count: 1182,
    median_wc_lbs: -25.3999939
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 42,
    membership_count: 1036,
    median_wc_lbs: -25
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 43,
    membership_count: 911,
    median_wc_lbs: -25.09999847
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 44,
    membership_count: 806,
    median_wc_lbs: -25
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 45,
    membership_count: 706,
    median_wc_lbs: -25.27657855
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 46,
    membership_count: 622,
    median_wc_lbs: -25.37657702
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 47,
    membership_count: 545,
    median_wc_lbs: -26
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 48,
    membership_count: 504,
    median_wc_lbs: -25.40000153
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 49,
    membership_count: 462,
    median_wc_lbs: -25.67681281
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 50,
    membership_count: 408,
    median_wc_lbs: -25.53680952
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 51,
    membership_count: 367,
    median_wc_lbs: -24.47130774
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 52,
    membership_count: 332,
    median_wc_lbs: -25
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 53,
    membership_count: 294,
    median_wc_lbs: -25.49703745
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 54,
    membership_count: 262,
    median_wc_lbs: -26.12478311
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 55,
    membership_count: 235,
    median_wc_lbs: -27
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 56,
    membership_count: 209,
    median_wc_lbs: -26
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 57,
    membership_count: 173,
    median_wc_lbs: -25.6000061
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 58,
    membership_count: 148,
    median_wc_lbs: -26.1072669
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 59,
    membership_count: 120,
    median_wc_lbs: -26.11750628
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 60,
    membership_count: 114,
    median_wc_lbs: -26.94819463
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 61,
    membership_count: 97,
    median_wc_lbs: -27
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 62,
    membership_count: 76,
    median_wc_lbs: -26.50000763
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 63,
    membership_count: 64,
    median_wc_lbs: -24.42542366
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 64,
    membership_count: 37,
    median_wc_lbs: -31.0851756
  },
  {
    bmi_bin: "overweight",
    sex: "F",
    tenure_week: 65,
    membership_count: 30,
    median_wc_lbs: -28.30000305
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 1,
    membership_count: 12298,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 2,
    membership_count: 12326,
    median_wc_lbs: -4.409245244
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 3,
    membership_count: 12016,
    median_wc_lbs: -6.600006104
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 4,
    membership_count: 11837,
    median_wc_lbs: -8.377572691
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 5,
    membership_count: 11266,
    median_wc_lbs: -10
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 6,
    membership_count: 10571,
    median_wc_lbs: -11.46403091
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 7,
    membership_count: 9800,
    median_wc_lbs: -12.99999046
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 8,
    membership_count: 8848,
    median_wc_lbs: -14
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 9,
    membership_count: 7868,
    median_wc_lbs: -15.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 10,
    membership_count: 6895,
    median_wc_lbs: -16.31421077
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 11,
    membership_count: 6011,
    median_wc_lbs: -17.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 12,
    membership_count: 5254,
    median_wc_lbs: -18.07791559
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 13,
    membership_count: 4455,
    median_wc_lbs: -19
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 14,
    membership_count: 3823,
    median_wc_lbs: -19.8416036
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 15,
    membership_count: 3258,
    median_wc_lbs: -20.50298029
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 16,
    membership_count: 2733,
    median_wc_lbs: -21.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 17,
    membership_count: 2335,
    median_wc_lbs: -22.1000061
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 18,
    membership_count: 1954,
    median_wc_lbs: -22.5
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 19,
    membership_count: 1651,
    median_wc_lbs: -23
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 20,
    membership_count: 1397,
    median_wc_lbs: -23.8999939
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 21,
    membership_count: 1164,
    median_wc_lbs: -24.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 22,
    membership_count: 1015,
    median_wc_lbs: -24.25084884
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 23,
    membership_count: 870,
    median_wc_lbs: -24.3999939
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 24,
    membership_count: 744,
    median_wc_lbs: -24.8999939
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 25,
    membership_count: 613,
    median_wc_lbs: -24.79998779
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 26,
    membership_count: 537,
    median_wc_lbs: -25.13270125
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 27,
    membership_count: 439,
    median_wc_lbs: -25.35316015
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 28,
    membership_count: 394,
    median_wc_lbs: -24.8020045
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 29,
    membership_count: 336,
    median_wc_lbs: -23.90496552
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 30,
    membership_count: 282,
    median_wc_lbs: -25.58681258
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 31,
    membership_count: 255,
    median_wc_lbs: -24.25084884
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 32,
    membership_count: 216,
    median_wc_lbs: -23.28449669
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 33,
    membership_count: 193,
    median_wc_lbs: -22.5
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 34,
    membership_count: 163,
    median_wc_lbs: -23.5
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 35,
    membership_count: 135,
    median_wc_lbs: -22
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 36,
    membership_count: 122,
    median_wc_lbs: -23.16403206
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 37,
    membership_count: 103,
    median_wc_lbs: -23.58945533
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 38,
    membership_count: 96,
    median_wc_lbs: -20.66173106
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 39,
    membership_count: 74,
    median_wc_lbs: -21.361728
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 40,
    membership_count: 70,
    median_wc_lbs: -21.15043434
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 41,
    membership_count: 64,
    median_wc_lbs: -17
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 42,
    membership_count: 60,
    median_wc_lbs: -21.91288366
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 43,
    membership_count: 53,
    median_wc_lbs: -20.19999695
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 44,
    membership_count: 44,
    median_wc_lbs: -21
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 45,
    membership_count: 44,
    median_wc_lbs: -19.84999847
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 46,
    membership_count: 36,
    median_wc_lbs: -16.71824896
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 47,
    membership_count: 39,
    median_wc_lbs: -18.03648876
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 48,
    membership_count: 32,
    median_wc_lbs: -19.36824285
  },
  {
    bmi_bin: "overweight",
    sex: "M",
    tenure_week: 49,
    membership_count: 30,
    median_wc_lbs: -16.42871994
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 1,
    membership_count: 21807,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 2,
    membership_count: 21152,
    median_wc_lbs: -4.100006104
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 3,
    membership_count: 20561,
    median_wc_lbs: -6
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 4,
    membership_count: 20380,
    median_wc_lbs: -7.716179176
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 5,
    membership_count: 19876,
    median_wc_lbs: -9.259408284
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 6,
    membership_count: 19280,
    median_wc_lbs: -10.80265421
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 7,
    membership_count: 18620,
    median_wc_lbs: -12.19999695
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 8,
    membership_count: 18025,
    median_wc_lbs: -13.66865353
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 9,
    membership_count: 17423,
    median_wc_lbs: -15
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 10,
    membership_count: 16531,
    median_wc_lbs: -16.30000305
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 11,
    membership_count: 15801,
    median_wc_lbs: -17.6000061
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 12,
    membership_count: 15031,
    median_wc_lbs: -18.80000305
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 13,
    membership_count: 14283,
    median_wc_lbs: -20
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 14,
    membership_count: 13449,
    median_wc_lbs: -21
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 15,
    membership_count: 12728,
    median_wc_lbs: -22.04622622
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 16,
    membership_count: 12008,
    median_wc_lbs: -23.30000305
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 17,
    membership_count: 11350,
    median_wc_lbs: -24.3999939
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 18,
    membership_count: 10639,
    median_wc_lbs: -25.40000916
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 19,
    membership_count: 9960,
    median_wc_lbs: -26.45547146
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 20,
    membership_count: 9285,
    median_wc_lbs: -27.5
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 21,
    membership_count: 8675,
    median_wc_lbs: -28.40000153
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 22,
    membership_count: 8013,
    median_wc_lbs: -29.3999939
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 23,
    membership_count: 7461,
    median_wc_lbs: -30.3999939
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 24,
    membership_count: 6910,
    median_wc_lbs: -31.09999084
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 25,
    membership_count: 6364,
    median_wc_lbs: -32
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 26,
    membership_count: 5858,
    median_wc_lbs: -33
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 27,
    membership_count: 5345,
    median_wc_lbs: -33.6000061
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 28,
    membership_count: 4899,
    median_wc_lbs: -34.3999939
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 29,
    membership_count: 4522,
    median_wc_lbs: -35
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 30,
    membership_count: 4155,
    median_wc_lbs: -36
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 31,
    membership_count: 3809,
    median_wc_lbs: -36.6000061
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 32,
    membership_count: 3497,
    median_wc_lbs: -37
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 33,
    membership_count: 3213,
    median_wc_lbs: -37.6000061
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 34,
    membership_count: 2936,
    median_wc_lbs: -38.20001221
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 35,
    membership_count: 2713,
    median_wc_lbs: -38.6000061
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 36,
    membership_count: 2453,
    median_wc_lbs: -39
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 37,
    membership_count: 2240,
    median_wc_lbs: -39.8999939
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 38,
    membership_count: 2071,
    median_wc_lbs: -40.19999695
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 39,
    membership_count: 1908,
    median_wc_lbs: -41
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 40,
    membership_count: 1723,
    median_wc_lbs: -41.3999939
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 41,
    membership_count: 1590,
    median_wc_lbs: -41.80000305
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 42,
    membership_count: 1462,
    median_wc_lbs: -42.3999939
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 43,
    membership_count: 1301,
    median_wc_lbs: -43
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 44,
    membership_count: 1196,
    median_wc_lbs: -43.45000076
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 45,
    membership_count: 1069,
    median_wc_lbs: -43.40000916
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 46,
    membership_count: 956,
    median_wc_lbs: -44.09245244
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 47,
    membership_count: 855,
    median_wc_lbs: -44.1000061
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 48,
    membership_count: 784,
    median_wc_lbs: -44.80000305
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 49,
    membership_count: 709,
    median_wc_lbs: -45.40000916
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 50,
    membership_count: 619,
    median_wc_lbs: -45.85615726
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 51,
    membership_count: 549,
    median_wc_lbs: -45.6000061
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 52,
    membership_count: 490,
    median_wc_lbs: -45.69999695
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 53,
    membership_count: 442,
    median_wc_lbs: -45.20000458
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 54,
    membership_count: 394,
    median_wc_lbs: -46.29999542
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 55,
    membership_count: 351,
    median_wc_lbs: -46.1000061
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 56,
    membership_count: 282,
    median_wc_lbs: -47
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 57,
    membership_count: 256,
    median_wc_lbs: -46.75
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 58,
    membership_count: 211,
    median_wc_lbs: -47
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 59,
    membership_count: 185,
    median_wc_lbs: -47.5
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 60,
    membership_count: 148,
    median_wc_lbs: -46.80000305
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 61,
    membership_count: 130,
    median_wc_lbs: -48.09999847
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 62,
    membership_count: 114,
    median_wc_lbs: -48.65084274
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 63,
    membership_count: 77,
    median_wc_lbs: -49.5
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 64,
    membership_count: 61,
    median_wc_lbs: -48.1000061
  },
  {
    bmi_bin: "obese1",
    sex: "F",
    tenure_week: 65,
    membership_count: 42,
    median_wc_lbs: -46.94999695
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 1,
    membership_count: 6035,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 2,
    membership_count: 6319,
    median_wc_lbs: -5.511556555
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 3,
    membership_count: 6245,
    median_wc_lbs: -7.999982834
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 4,
    membership_count: 6256,
    median_wc_lbs: -10
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 5,
    membership_count: 6099,
    median_wc_lbs: -12
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 6,
    membership_count: 5875,
    median_wc_lbs: -14
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 7,
    membership_count: 5663,
    median_wc_lbs: -15.65281725
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 8,
    membership_count: 5429,
    median_wc_lbs: -17.3999939
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 9,
    membership_count: 5123,
    median_wc_lbs: -18.959768
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 10,
    membership_count: 4816,
    median_wc_lbs: -20.40487025
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 11,
    membership_count: 4520,
    median_wc_lbs: -21.8999939
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 12,
    membership_count: 4164,
    median_wc_lbs: -23.36899643
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 13,
    membership_count: 3851,
    median_wc_lbs: -24.6000061
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 14,
    membership_count: 3506,
    median_wc_lbs: -25.99999714
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 15,
    membership_count: 3193,
    median_wc_lbs: -27.11684816
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 16,
    membership_count: 2904,
    median_wc_lbs: -28
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 17,
    membership_count: 2649,
    median_wc_lbs: -29.5
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 18,
    membership_count: 2379,
    median_wc_lbs: -30.80000305
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 19,
    membership_count: 2151,
    median_wc_lbs: -31.80000305
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 20,
    membership_count: 1913,
    median_wc_lbs: -32.99999428
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 21,
    membership_count: 1702,
    median_wc_lbs: -34.19999695
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 22,
    membership_count: 1537,
    median_wc_lbs: -35.27396195
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 23,
    membership_count: 1334,
    median_wc_lbs: -36.33813816
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 24,
    membership_count: 1211,
    median_wc_lbs: -37.19999695
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 25,
    membership_count: 1064,
    median_wc_lbs: -38.13996968
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 26,
    membership_count: 971,
    median_wc_lbs: -38.69999695
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 27,
    membership_count: 847,
    median_wc_lbs: -39.59999084
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 28,
    membership_count: 753,
    median_wc_lbs: -40.3999939
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 29,
    membership_count: 676,
    median_wc_lbs: -41.00299728
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 30,
    membership_count: 582,
    median_wc_lbs: -42
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 31,
    membership_count: 525,
    median_wc_lbs: -42.99014113
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 32,
    membership_count: 469,
    median_wc_lbs: -43.1000061
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 33,
    membership_count: 406,
    median_wc_lbs: -43.5
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 34,
    membership_count: 364,
    median_wc_lbs: -44.44999886
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 35,
    membership_count: 338,
    median_wc_lbs: -44.51668512
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 36,
    membership_count: 287,
    median_wc_lbs: -45.5
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 37,
    membership_count: 264,
    median_wc_lbs: -45.69999695
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 38,
    membership_count: 230,
    median_wc_lbs: -46.70000458
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 39,
    membership_count: 196,
    median_wc_lbs: -47.29999542
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 40,
    membership_count: 180,
    median_wc_lbs: -47.92015208
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 41,
    membership_count: 164,
    median_wc_lbs: -48.40000153
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 42,
    membership_count: 133,
    median_wc_lbs: -49
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 43,
    membership_count: 118,
    median_wc_lbs: -49
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 44,
    membership_count: 100,
    median_wc_lbs: -49.3999939
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 45,
    membership_count: 95,
    median_wc_lbs: -50.7063203
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 46,
    membership_count: 77,
    median_wc_lbs: -51.1000061
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 47,
    membership_count: 67,
    median_wc_lbs: -52.1000061
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 48,
    membership_count: 60,
    median_wc_lbs: -52.80071348
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 49,
    membership_count: 55,
    median_wc_lbs: -52.5
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 50,
    membership_count: 49,
    median_wc_lbs: -52.5
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 51,
    membership_count: 46,
    median_wc_lbs: -52.65000153
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 52,
    membership_count: 37,
    median_wc_lbs: -52.6000061
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 53,
    membership_count: 34,
    median_wc_lbs: -53.34999847
  },
  {
    bmi_bin: "obese1",
    sex: "M",
    tenure_week: 54,
    membership_count: 32,
    median_wc_lbs: -54.00662712
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 1,
    membership_count: 6561,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 2,
    membership_count: 6259,
    median_wc_lbs: -4.600006104
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 3,
    membership_count: 5962,
    median_wc_lbs: -6.613867866
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 4,
    membership_count: 5825,
    median_wc_lbs: -8.5
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 5,
    membership_count: 5597,
    median_wc_lbs: -10.19999695
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 6,
    membership_count: 5373,
    median_wc_lbs: -12
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 7,
    membership_count: 5143,
    median_wc_lbs: -13.66865353
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 8,
    membership_count: 4946,
    median_wc_lbs: -15.21189945
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 9,
    membership_count: 4701,
    median_wc_lbs: -16.97558746
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 10,
    membership_count: 4426,
    median_wc_lbs: -18.3999939
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 11,
    membership_count: 4254,
    median_wc_lbs: -19.89699364
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 12,
    membership_count: 4006,
    median_wc_lbs: -21.19999695
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 13,
    membership_count: 3826,
    median_wc_lbs: -22.79999542
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 14,
    membership_count: 3672,
    median_wc_lbs: -24.19999695
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 15,
    membership_count: 3494,
    median_wc_lbs: -25.6000061
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 16,
    membership_count: 3300,
    median_wc_lbs: -27.00000191
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 17,
    membership_count: 3110,
    median_wc_lbs: -28.30000305
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 18,
    membership_count: 2996,
    median_wc_lbs: -29.98286429
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 19,
    membership_count: 2826,
    median_wc_lbs: -31
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 20,
    membership_count: 2695,
    median_wc_lbs: -32.18748692
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 21,
    membership_count: 2542,
    median_wc_lbs: -33.3999939
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 22,
    membership_count: 2403,
    median_wc_lbs: -34.61256844
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 23,
    membership_count: 2289,
    median_wc_lbs: -36
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 24,
    membership_count: 2162,
    median_wc_lbs: -37
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 25,
    membership_count: 2063,
    median_wc_lbs: -38.36043698
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 26,
    membership_count: 1956,
    median_wc_lbs: -39.6000061
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 27,
    membership_count: 1820,
    median_wc_lbs: -40.56505961
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 28,
    membership_count: 1732,
    median_wc_lbs: -41.89391186
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 29,
    membership_count: 1607,
    median_wc_lbs: -42.99014113
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 30,
    membership_count: 1550,
    median_wc_lbs: -43.88599372
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 31,
    membership_count: 1476,
    median_wc_lbs: -44.80000305
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 32,
    membership_count: 1371,
    median_wc_lbs: -45.63568154
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 33,
    membership_count: 1304,
    median_wc_lbs: -46.49900341
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 34,
    membership_count: 1229,
    median_wc_lbs: -47.3999939
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 35,
    membership_count: 1148,
    median_wc_lbs: -48.3999939
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 36,
    membership_count: 1065,
    median_wc_lbs: -48.80000305
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 37,
    membership_count: 995,
    median_wc_lbs: -49.38355009
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 38,
    membership_count: 939,
    median_wc_lbs: -50.6000061
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 39,
    membership_count: 846,
    median_wc_lbs: -51.1236221
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 40,
    membership_count: 783,
    median_wc_lbs: -52.02909051
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 41,
    membership_count: 750,
    median_wc_lbs: -51.80000305
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 42,
    membership_count: 688,
    median_wc_lbs: -52.8999939
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 43,
    membership_count: 626,
    median_wc_lbs: -53.04999542
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 44,
    membership_count: 580,
    median_wc_lbs: -53.05000877
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 45,
    membership_count: 525,
    median_wc_lbs: -54
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 46,
    membership_count: 489,
    median_wc_lbs: -54.80001259
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 47,
    membership_count: 451,
    median_wc_lbs: -54.6000061
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 48,
    membership_count: 398,
    median_wc_lbs: -55.99870898
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 49,
    membership_count: 381,
    median_wc_lbs: -55.69999695
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 50,
    membership_count: 338,
    median_wc_lbs: -56.76903251
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 51,
    membership_count: 301,
    median_wc_lbs: -56.6000061
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 52,
    membership_count: 262,
    median_wc_lbs: -57.08429698
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 53,
    membership_count: 252,
    median_wc_lbs: -56.75
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 54,
    membership_count: 224,
    median_wc_lbs: -57.40000153
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 55,
    membership_count: 189,
    median_wc_lbs: -58
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 56,
    membership_count: 172,
    median_wc_lbs: -57.09999847
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 57,
    membership_count: 143,
    median_wc_lbs: -57.3999939
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 58,
    membership_count: 122,
    median_wc_lbs: -59.71240234
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 59,
    membership_count: 106,
    median_wc_lbs: -59
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 60,
    membership_count: 95,
    median_wc_lbs: -58.8634341
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 61,
    membership_count: 73,
    median_wc_lbs: -58.52611028
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 62,
    membership_count: 60,
    median_wc_lbs: -59.51240539
  },
  {
    bmi_bin: "obese2",
    sex: "F",
    tenure_week: 63,
    membership_count: 39,
    median_wc_lbs: -55.72623854
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 1,
    membership_count: 1479,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 2,
    membership_count: 1503,
    median_wc_lbs: -6
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 3,
    membership_count: 1443,
    median_wc_lbs: -8.399993896
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 4,
    membership_count: 1429,
    median_wc_lbs: -10.80265421
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 5,
    membership_count: 1364,
    median_wc_lbs: -13.00727683
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 6,
    membership_count: 1327,
    median_wc_lbs: -15.19999695
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 7,
    membership_count: 1270,
    median_wc_lbs: -17
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 8,
    membership_count: 1224,
    median_wc_lbs: -19
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 9,
    membership_count: 1148,
    median_wc_lbs: -20.80000305
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 10,
    membership_count: 1112,
    median_wc_lbs: -22.5
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 11,
    membership_count: 1062,
    median_wc_lbs: -24.47130774
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 12,
    membership_count: 989,
    median_wc_lbs: -25.8999939
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 13,
    membership_count: 947,
    median_wc_lbs: -27.5
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 14,
    membership_count: 884,
    median_wc_lbs: -29.00001144
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 15,
    membership_count: 857,
    median_wc_lbs: -30.64425781
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 16,
    membership_count: 777,
    median_wc_lbs: -32.40000916
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 17,
    membership_count: 746,
    median_wc_lbs: -33.97559587
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 18,
    membership_count: 726,
    median_wc_lbs: -35.20000458
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 19,
    membership_count: 651,
    median_wc_lbs: -37
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 20,
    membership_count: 599,
    median_wc_lbs: -38.59999084
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 21,
    membership_count: 565,
    median_wc_lbs: -40
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 22,
    membership_count: 517,
    median_wc_lbs: -41.2264363
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 23,
    membership_count: 487,
    median_wc_lbs: -42.6000061
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 24,
    membership_count: 440,
    median_wc_lbs: -44
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 25,
    membership_count: 407,
    median_wc_lbs: -45
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 26,
    membership_count: 373,
    median_wc_lbs: -45.80000305
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 27,
    membership_count: 338,
    median_wc_lbs: -46.25000572
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 28,
    membership_count: 315,
    median_wc_lbs: -46.5
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 29,
    membership_count: 292,
    median_wc_lbs: -47.44999695
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 30,
    membership_count: 272,
    median_wc_lbs: -49.0815456
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 31,
    membership_count: 247,
    median_wc_lbs: -50.7063203
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 32,
    membership_count: 225,
    median_wc_lbs: -49.79998779
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 33,
    membership_count: 207,
    median_wc_lbs: -51
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 34,
    membership_count: 201,
    median_wc_lbs: -51.80000305
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 35,
    membership_count: 179,
    median_wc_lbs: -52.20001221
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 36,
    membership_count: 165,
    median_wc_lbs: -52.91094292
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 37,
    membership_count: 140,
    median_wc_lbs: -53.76326361
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 38,
    membership_count: 132,
    median_wc_lbs: -54.75174161
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 39,
    membership_count: 108,
    median_wc_lbs: -54.00000381
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 40,
    membership_count: 96,
    median_wc_lbs: -54.19999695
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 41,
    membership_count: 88,
    median_wc_lbs: -54.85778582
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 42,
    membership_count: 79,
    median_wc_lbs: -55
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 43,
    membership_count: 71,
    median_wc_lbs: -55.6000061
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 44,
    membership_count: 66,
    median_wc_lbs: -55.52824167
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 45,
    membership_count: 48,
    median_wc_lbs: -57
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 46,
    membership_count: 53,
    median_wc_lbs: -57.19999695
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 47,
    membership_count: 44,
    median_wc_lbs: -56.79999542
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 48,
    membership_count: 43,
    median_wc_lbs: -57.32018817
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 49,
    membership_count: 38,
    median_wc_lbs: -57.74999237
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 50,
    membership_count: 33,
    median_wc_lbs: -56.5
  },
  {
    bmi_bin: "obese2",
    sex: "M",
    tenure_week: 51,
    membership_count: 31,
    median_wc_lbs: -55.30000305
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 1,
    membership_count: 3681,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 2,
    membership_count: 3459,
    median_wc_lbs: -5
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 3,
    membership_count: 3211,
    median_wc_lbs: -7
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 4,
    membership_count: 3047,
    median_wc_lbs: -9
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 5,
    membership_count: 2805,
    median_wc_lbs: -11
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 6,
    membership_count: 2586,
    median_wc_lbs: -12.99898911
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 7,
    membership_count: 2415,
    median_wc_lbs: -14.3999939
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 8,
    membership_count: 2221,
    median_wc_lbs: -16.19999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 9,
    membership_count: 2060,
    median_wc_lbs: -18
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 10,
    membership_count: 1942,
    median_wc_lbs: -19.79998779
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 11,
    membership_count: 1762,
    median_wc_lbs: -21.19999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 12,
    membership_count: 1603,
    median_wc_lbs: -22.79801178
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 13,
    membership_count: 1479,
    median_wc_lbs: -24.19999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 14,
    membership_count: 1373,
    median_wc_lbs: -25.50397491
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 15,
    membership_count: 1302,
    median_wc_lbs: -27
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 16,
    membership_count: 1216,
    median_wc_lbs: -28.6000061
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 17,
    membership_count: 1119,
    median_wc_lbs: -30.4980011
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 18,
    membership_count: 1048,
    median_wc_lbs: -31.6000061
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 19,
    membership_count: 995,
    median_wc_lbs: -33.51025712
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 20,
    membership_count: 939,
    median_wc_lbs: -34.80000305
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 21,
    membership_count: 855,
    median_wc_lbs: -36.19999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 22,
    membership_count: 803,
    median_wc_lbs: -37.25812567
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 23,
    membership_count: 745,
    median_wc_lbs: -38.58089588
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 24,
    membership_count: 712,
    median_wc_lbs: -39.94983414
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 25,
    membership_count: 651,
    median_wc_lbs: -41.19999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 26,
    membership_count: 610,
    median_wc_lbs: -42.45000458
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 27,
    membership_count: 563,
    median_wc_lbs: -43.69999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 28,
    membership_count: 534,
    median_wc_lbs: -44.8999939
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 29,
    membership_count: 496,
    median_wc_lbs: -45.69998932
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 30,
    membership_count: 462,
    median_wc_lbs: -46.97923429
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 31,
    membership_count: 431,
    median_wc_lbs: -48
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 32,
    membership_count: 401,
    median_wc_lbs: -50
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 33,
    membership_count: 381,
    median_wc_lbs: -50.3999939
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 34,
    membership_count: 347,
    median_wc_lbs: -52
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 35,
    membership_count: 323,
    median_wc_lbs: -53.19999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 36,
    membership_count: 304,
    median_wc_lbs: -53.20000458
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 37,
    membership_count: 287,
    median_wc_lbs: -54.3999939
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 38,
    membership_count: 255,
    median_wc_lbs: -55.6000061
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 39,
    membership_count: 246,
    median_wc_lbs: -55.3999939
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 40,
    membership_count: 228,
    median_wc_lbs: -56.25
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 41,
    membership_count: 201,
    median_wc_lbs: -56.59999084
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 42,
    membership_count: 184,
    median_wc_lbs: -56.2089369
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 43,
    membership_count: 170,
    median_wc_lbs: -55.94999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 44,
    membership_count: 164,
    median_wc_lbs: -56.59999847
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 45,
    membership_count: 147,
    median_wc_lbs: -56
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 46,
    membership_count: 136,
    median_wc_lbs: -57.75
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 47,
    membership_count: 122,
    median_wc_lbs: -56.70000458
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 48,
    membership_count: 110,
    median_wc_lbs: -57.65000153
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 49,
    membership_count: 99,
    median_wc_lbs: -58.8999939
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 50,
    membership_count: 95,
    median_wc_lbs: -58.64295838
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 51,
    membership_count: 77,
    median_wc_lbs: -59.19999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 52,
    membership_count: 70,
    median_wc_lbs: -58.69999695
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 53,
    membership_count: 55,
    median_wc_lbs: -61.1000061
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 54,
    membership_count: 56,
    median_wc_lbs: -59.75
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 55,
    membership_count: 45,
    median_wc_lbs: -60.3999939
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 56,
    membership_count: 46,
    median_wc_lbs: -60.6135641
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 57,
    membership_count: 40,
    median_wc_lbs: -62.06013017
  },
  {
    bmi_bin: "obese3",
    sex: "F",
    tenure_week: 58,
    membership_count: 35,
    median_wc_lbs: -62.61128582
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 1,
    membership_count: 502,
    median_wc_lbs: 0
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 2,
    membership_count: 479,
    median_wc_lbs: -5.799987793
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 3,
    membership_count: 440,
    median_wc_lbs: -8.399993896
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 4,
    membership_count: 425,
    median_wc_lbs: -10.6000061
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 5,
    membership_count: 418,
    median_wc_lbs: -13
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 6,
    membership_count: 390,
    median_wc_lbs: -15.20593979
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 7,
    membership_count: 377,
    median_wc_lbs: -17.30001831
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 8,
    membership_count: 351,
    median_wc_lbs: -19.19998169
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 9,
    membership_count: 316,
    median_wc_lbs: -20.83367705
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 10,
    membership_count: 292,
    median_wc_lbs: -22.33333951
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 11,
    membership_count: 273,
    median_wc_lbs: -24
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 12,
    membership_count: 258,
    median_wc_lbs: -25.55000305
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 13,
    membership_count: 246,
    median_wc_lbs: -27.44999695
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 14,
    membership_count: 222,
    median_wc_lbs: -29
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 15,
    membership_count: 203,
    median_wc_lbs: -30.99998474
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 16,
    membership_count: 195,
    median_wc_lbs: -32
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 17,
    membership_count: 184,
    median_wc_lbs: -34.34999084
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 18,
    membership_count: 167,
    median_wc_lbs: -36.80000305
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 19,
    membership_count: 149,
    median_wc_lbs: -38
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 20,
    membership_count: 147,
    median_wc_lbs: -38.8999939
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 21,
    membership_count: 141,
    median_wc_lbs: -41.3999939
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 22,
    membership_count: 134,
    median_wc_lbs: -41.8439088
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 23,
    membership_count: 122,
    median_wc_lbs: -42.65000153
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 24,
    membership_count: 117,
    median_wc_lbs: -45.29998779
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 25,
    membership_count: 99,
    median_wc_lbs: -45.6000061
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 26,
    membership_count: 99,
    median_wc_lbs: -46.99399948
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 27,
    membership_count: 91,
    median_wc_lbs: -46.40000916
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 28,
    membership_count: 94,
    median_wc_lbs: -47.00000763
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 29,
    membership_count: 80,
    median_wc_lbs: -49.3999939
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 30,
    membership_count: 73,
    median_wc_lbs: -50.1000061
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 31,
    membership_count: 71,
    median_wc_lbs: -52.3999939
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 32,
    membership_count: 58,
    median_wc_lbs: -53.50000763
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 33,
    membership_count: 52,
    median_wc_lbs: -55.1000061
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 34,
    membership_count: 54,
    median_wc_lbs: -56.1000061
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 35,
    membership_count: 49,
    median_wc_lbs: -57.5
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 36,
    membership_count: 44,
    median_wc_lbs: -58.05000305
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 37,
    membership_count: 38,
    median_wc_lbs: -58.75
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 38,
    membership_count: 41,
    median_wc_lbs: -57
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 39,
    membership_count: 37,
    median_wc_lbs: -59.6000061
  },
  {
    bmi_bin: "obese3",
    sex: "M",
    tenure_week: 40,
    membership_count: 34,
    median_wc_lbs: -60.80000305
  }
];
